/**
 * Roles que el ORG_OWNER puede asignar al invitar o editar miembros.
 *
 * Excluye `ORG_OWNER` (no se permite transferir propiedad desde la UI por ahora).
 */
export const ASSIGNABLE_ROLES = ['ORG_MANAGER', 'ORG_ACCOUNTANT'] as const
export type AssignableRole = (typeof ASSIGNABLE_ROLES)[number]

/**
 * Labels legibles para TODOS los roles conocidos del backend. Incluye
 * `ORG_OWNER` porque puede aparecer en la tabla de miembros aunque no sea
 * asignable desde los formularios.
 */
const ALL_ROLE_LABELS: Record<string, string> = {
  ORG_OWNER: 'Dueño',
  ORG_MANAGER: 'Gestor',
  ORG_ACCOUNTANT: 'Contable',
}

export const ROLE_LABELS: Record<AssignableRole, string> = {
  ORG_MANAGER: ALL_ROLE_LABELS.ORG_MANAGER!,
  ORG_ACCOUNTANT: ALL_ROLE_LABELS.ORG_ACCOUNTANT!,
}

export const ROLE_DESCRIPTIONS: Record<AssignableRole, string> = {
  ORG_MANAGER: 'Gestiona negocios, servicios y la operación del día a día.',
  ORG_ACCOUNTANT: 'Acceso a facturación y reportes financieros.',
}

export function getRoleLabel(roleName: string): string {
  return ALL_ROLE_LABELS[roleName] ?? roleName
}
